import axios from "../../../Shared/auth-header";
import AuthService from "../../../Auth/AuthService";
import React, { Component, Fragment } from "react";
import UserConstant from "./UsersConstant";
import PermissionFeature from "../../../Permissions/PermissionFeature";
import moment from "moment";
import { OverlayTrigger, Popover } from "react-bootstrap";

import { toast } from "react-toastify";
export default {
  CreateCostomColumnHeader: (colHeaders) => {
    let searchCols = [];
    let {
      dateColumns,
      boolColumns,
      currencyColumns,
      addressColumns,
      phoneColumns,
      latLongColumn,
      emailColumns,
    } = UserConstant;
    colHeaders.map((col, index, array) => {
      let checkContactColumn = () => {
        if (
          emailColumns.indexOf(col.backend_column_name) != -1 ||
          phoneColumns.indexOf(col.backend_column_name) != -1 ||
          addressColumns.indexOf(col.backend_column_name) != -1
        ) {
          let hasPermission = AuthService.canView(
            PermissionFeature.MembersContact
          );
          if (!hasPermission) return false;
        }
        return true;
      };
      let colDef = {
        text: col.column_name,
        dataField: col.backend_column_name,
        sort: true,
        formatter: (cell, row) => {
          let hasPermission = AuthService.canView(col.permission_feature_id);
          if (!hasPermission) return "";

          hasPermission = AuthService.canSPView(
            col.permission_feature_id,
            row.regionId,
            row.facilityId,
            row.id
          );
          if (!hasPermission) return "";

          if (
            emailColumns.indexOf(col.backend_column_name) != -1 ||
            phoneColumns.indexOf(col.backend_column_name) != -1 ||
            addressColumns.indexOf(col.backend_column_name) != -1
          ) {
            hasPermission = AuthService.canSPView(
              PermissionFeature.MembersContact,
              row.regionId,
              row.facilityId,
              row.id
            );
            if (!hasPermission) return "";
          }

          if (latLongColumn.indexOf(col.backend_column_name) != -1) {
            hasPermission = AuthService.canSPView(
              PermissionFeature.AddressLatLong,
              row.regionId,
              row.facilityId,
              row.id
            );
            if (!hasPermission) return "";
            else {
              return cell !== null && cell !== undefined
                ? parseFloat(cell).toFixed(5)
                : null;
            }
          }

          if (dateColumns.indexOf(col.backend_column_name) != -1) {
            return moment(cell).isValid()
              ? moment(cell).format("MM/DD/YYYY")
              : " ";
          } else {
            if (boolColumns.indexOf(col.backend_column_name) != -1) {
              if (col.backend_column_name == "isActive") {
                if (cell == null) {
                  return "No Status";
                } else {
                  if (cell != "Active" && cell != "InActive") {
                    return cell === true ? "Active" : "In Active";
                  }
                  return cell;
                }
              } else {
                if (cell == null) {
                  return "No";
                } else {
                  return cell === true ? "Yes" : "No";
                }
              }
            } else {
              if (emailColumns.indexOf(col.backend_column_name) != -1) {
                return cell == null ? (
                  ""
                ) : cell.trim().length == 0 ? (
                  ""
                ) : (
                  <a target="_blank" href={`mailto:${cell}`}>
                    <span className="email-to">{cell}</span>
                  </a>
                );
              } else {
                if (phoneColumns.indexOf(col.backend_column_name) != -1) {
                  return cell == null ? (
                    ""
                  ) : cell.trim().length == 0 ? (
                    ""
                  ) : (
                    <a target="_blank" href={`tel:${cell}`}>
                      <span className="telephone">{cell}</span>
                    </a>
                  );
                } else {
                  if (addressColumns.indexOf(col.backend_column_name) != -1) {
                    if (!cell || cell == null || cell.trim().length <= 0) {
                      return "";
                    } else {
                      let address = cell
                        // Remove latitude/longitude starting with |
                        .replace(/\|\s*-?\d+(\.\d+)?\s*,\s*-?\d+(\.\d+)?/, "")
                        // Replace multiple commas with a single comma
                        .replace(/,+/g, ",")
                        // Remove commas directly before or after parentheses
                        .replace(/\s*,\s*\(/g, " (")
                        .replace(/\)\s*,/g, ")")
                        // Remove trailing commas and spaces
                        .replace(/,\s*$/, "")
                        // Remove extra spaces
                        .replace(/\s+/g, " ")
                        .trim();

                      if (address) {
                        return (
                          <>
                            <a
                              target="_blank"
                              className="view-map"
                              href={`http://maps.google.com/?q=${address}`}
                            >
                              <span className="view-map">{address}</span>
                            </a>
                          </>
                        );
                      }
                    }
                  } else if (col.backend_column_name == "facebookid") {
                    if (
                      cell &&
                      cell != null &&
                      cell != null &&
                      cell != undefined
                    ) {
                      return (
                        <a
                          target="_blank"
                          href={"https://facebook.com/" + cell}
                        >
                          <span className="">{cell}</span>
                        </a>
                      );
                    }
                    return cell;
                  } else if (col.backend_column_name == "positions") {
                    if (
                      cell &&
                      cell != null &&
                      cell != null &&
                      cell != undefined
                    ) {
                      const positionList = cell
                        .split("|")
                        .map((pos, index) => <li key={index}>{pos.trim()}</li>);
                      const popoverHoverFocus = (
                        <Popover
                          id="position-popover"
                          style={{
                            zIndex: 1055,
                            maxWidth: "400px",
                            whiteSpace: "normal",
                          }}
                        >
                          <Popover.Title as="h6">Positions</Popover.Title>
                          <Popover.Content>
                            <ul
                              className="m-0 p-0"
                              style={{ listStyleType: "none" }}
                            >
                              {positionList}
                            </ul>
                          </Popover.Content>
                        </Popover>
                      );
                      return (
                        <OverlayTrigger
                          trigger={["focus", "hover"]}
                          placement="bottom"
                          overlay={popoverHoverFocus}
                        >
                          <div
                            onClick={(e) => {
                              e.preventDefault();
                              e.nativeEvent.stopImmediatePropagation();
                              e.stopPropagation();
                            }}
                            className="text-truncate"
                            style={{
                              maxWidth: "150px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            <span variant="link" className="w-100">
                              {" "}
                              {cell.length > 30
                                ? cell.substring(0, 30) + "..."
                                : cell}
                            </span>
                          </div>
                        </OverlayTrigger>
                      );
                    }
                    return cell;
                  } else if (
                    currencyColumns.indexOf(col.backend_column_name) != -1
                  ) {
                    const formatter = new Intl.NumberFormat("en-US", {
                      style: "currency",
                      currency: "USD",
                      minimumFractionDigits: 2,
                    });
                    let value = cell;
                    if (col.backend_column_name == "drfDonation") {
                      value = parseFloat(cell);
                    }

                    return moment(value).isValid()
                      ? formatter.format(value)
                      : " ";
                  } else {
                    return cell;
                  }
                }
              }
            }
          }
        },
      };
      if (
        AuthService.canView(col.permission_feature_id) &&
        checkContactColumn()
      ) {
        searchCols.push(colDef);
      }
    });
    return searchCols;
  },
};
